module.exports = __webpack_public_path__ + "img/qing_2.f1c968bf.png";